<template>
  <aside v-if="portefeuilles" class="menu">
    <b-modal :active.sync="showModal" has-modal-card>
      <CGAModal :documentUrl="pdfUrl" :show-modal="showModal" @close-modal="showModal = false" v-show="showModal" />
    </b-modal>
    <div v-for="portefeuille in portefeuilles" :key="'portefeuille' + portefeuille.id">
      <div class="menu-head">
        <a class="has-toggle" @click="handleToggleClick(portefeuille.id)">
          <div>
            <b-icon :icon="expandedPortefeuille === portefeuille.id
                ? 'minus-square'
                : 'plus-square'
              " />
          </div>
        </a>
        <router-link :to="`/portefeuille/${portefeuille.id}/`" @click.native="getCGA(portefeuille.id)">
          {{ portefeuille.name }}
        </router-link>
      </div>
      <ul v-show="expandedPortefeuille === portefeuille.id" class="menu-list">
        <li v-for="site in sites" :key="'site' + site.id">
          <a class="has-toggle" @click="toggleExpand(site.id)">
            <div>
              <b-icon :icon="isExpanded(site.id) ? 'minus-square' : 'plus-square'" />
            </div>
            {{ site.name }}
          </a>
          <ul v-show="isExpanded(site.id)">
            <li v-for="bien in site.biens" :key="'bien' + bien.id">
              <router-link :to="`/portefeuille/${portefeuille.id}/${site.id}/${bien.id}`">
                {{ bien.name }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex'
import CGAModal from './CGAModal.vue'

export default {
  components: {
    CGAModal,
  },
  data () {
    return {
      expanded: [],
      expandedPortefeuille: null,
      showModal: false,
      pdfUrl: 'empty',
    }
  },
  computed: {
    ...mapState({
      biens: (state) => state.inv.biens,
    }),
    ...mapState(['user']),
    sites () {
      return this.biens
        .filter((i) => i.portefeuille === this.expandedPortefeuille)
        .reduce((sites, bien) => {
          let siteIndex = sites.findIndex((i) => i.id === bien.site)
          if (siteIndex === -1) {
            siteIndex = sites.length
            sites.push({
              id: bien.site,
              name: bien.siteName,
              biens: [],
            })
          }
          sites[siteIndex].biens.push({
            id: bien.id,
            name: bien.name,
          })
          return sites
        }, [])
    },
    portefeuilles () {
      return this.biens.reduce((portefeuilles, bien) => {
        let portefeuilleIndex = portefeuilles.findIndex(
          (i) => i.id === bien.portefeuille
        )
        if (portefeuilleIndex === -1) {
          portefeuilleIndex = portefeuilles.length
          portefeuilles.push({
            id: bien.portefeuille,
            name: bien.portefeuilleName,
          })
        }
        return portefeuilles
      }, [])
    },
  },
  created () {
    try {
      this.$store.dispatch('inv/getBiens')
    } catch (e) {
      console.log('e', e)
      this.apiError(e)
    }

    if (this.$route.params.portefeuille) {
      this.expandedPortefeuille = +this.$route.params.portefeuille
    }
    if (this.$route.params.site) {
      this.toggleExpand(+this.$route.params.site)
    }
  },
  methods: {
    async handleToggleClick (portefeuilleId) {
      // Obtenez la valeur de getCGA(portefeuilleId)
      const isCga = await this.isCGA(portefeuilleId)

      // Vérifiez si le dépliage est autorisé
      if ((isCga.isMandatory === true && isCga.isUserAccepted === true) || isCga.isMandatory === false) {
        // Basculer l'état du portefeuille
        this.expandedPortefeuille = this.expandedPortefeuille === portefeuilleId ? null : portefeuilleId
      }
    },
    isExpanded (id) {
      return this.expanded.indexOf(id) !== -1
    },
    toggleExpand (id) {
      const index = this.expanded.indexOf(id)
      if (index === -1) {
        this.expanded.push(id)
      } else {
        this.expanded.splice(index, 1)
      }
    },
    getCGA (id) {
      this.$store
        .dispatch('getCgaValue', {
          user: this.user.name,
          id: id,
        })
        .then((cga) => {
          if (cga.isMandatory === true) {
            if (cga.isUserAccepted === false) {
              this.showModal = true

              this.pdfUrl = cga.fileData64
            }
          }
        })
    },
    isCGA (id) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('getCgaValue', {
            user: this.user.name,
            id: id,
          })
          .then((cga) => {
            // Résolvez la promesse avec la valeur de cga
            resolve(cga)
          })
          .catch((error) => {
            // Rejetez la promesse en cas d'erreur
            reject(error)
          })
        // this.getCGA(id)
      })
    },
    closeModal () {
      this.showModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.router-link-active {
  font-weight: bold;
  background: #f5f5f5;
}

ul.menu-list {
  margin-bottom: 1em;
}

div.menu-head {
  display: flex;

  a.has-toggle {
    font-size: 0.8em;
  }

  a {
    background: none;
  }
}

.menu-head:hover {
  background-color: #f5f5f5;
}

router-link:hover {
  color: #ed9e1a;
}
</style>
